var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"text","placeholder":"Search for a movie or TV series","spellcheck":"false","translate":"false"},domProps:{"value":_vm.data.search},on:{"input":event => _vm.data.search = event.target.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }